import axios, { AxiosInstance } from 'axios';
import qs from 'qs';

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_ROOT_URL as string,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
axiosInstance.defaults.headers.common['X-PUNO-TZ'] = tz;
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
